import React from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import theme from '../theme';
import CloseIcon from '@mui/icons-material/Close';

const CmpModal = ({ open, onClose = () => {}, title = '', children, height, width }) => {
  return (
    <Modal open={open} className="modal">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: width,
          bgcolor: '#fff',
          boxShadow: `0px 4px 20px ${theme.palette.primary.main}`,
          borderRadius: 2,
          border: `2px solid ${theme.palette.primary.main}`
        }}>
        <div className="modal-head">
          <Typography variant="subtilte1" sx={{ margin: 0 }}>
            {title}
          </Typography>
          <IconButton onClick={onClose} sx={{ cursor: 'pointer' }}>
            <CloseIcon />
          </IconButton>
        </div>

        <Box sx={{ height: height, overflowY: 'auto' }}>{children}</Box>
      </Box>
    </Modal>
  );
};

export default CmpModal;
